import EditAnnouncementContainer from "../containers/EditAnnouncementContainer";

const EditAnnouncementPage = () => {
  return (
    <EditAnnouncementContainer />
  );
};

export default EditAnnouncementPage;
